import { CheckBadgeIcon, PencilSquareIcon } from "@heroicons/react/24/outline";
import { useState, useEffect } from "react";
import { TWclassNames } from "../../../utils/Div";

import { ReportStatusDialog } from "./report-status-dialog";

export const ReportStatusButton = (props) => {
  const { report, isLoading } = props;
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(!open)}
        type="button"
        className={TWclassNames(
          "border-green-400",
          "group flex items-center p-2 border-2 rounded-md"
        )}
      >
        <CheckBadgeIcon
          className="h-4 w-4 flex-shrink-0 text-black group-hover:text-gray-500 "
          aria-hidden="true"
        />
        <span className="sr-only">Notes, view notes</span>
      </button>

      {/* Dialog START */}
      <ReportStatusDialog
        report={report}
        open={open}
        isLoading={isLoading}
        // onLoading={(state) => setIsLoading(state)}
        onClose={() => setOpen(!open)}
        onRefresh={() => props.onRefresh()}
        {...props}
      />
      {/* Dialog END */}
    </>
  );
};

